import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, BedDouble, Users, CalendarCheck, CreditCard, Shirt, FileText, Settings, LogOut, Menu, X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const links = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/rooms', icon: BedDouble, label: 'Rooms' },
  { to: '/students', icon: Users, label: 'Students' },
  { to: '/reservations', icon: CalendarCheck, label: 'Reservations' },
  { to: '/tenancies', icon: CreditCard, label: 'Tenancies' },
  { to: '/laundry', icon: Shirt, label: 'Laundry' },
  { to: '/agreements', icon: FileText, label: 'Agreements' },
  { to: '/settings', icon: Settings, label: 'Settings' },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);

  const nav = (
    <nav className="flex flex-col h-full">
      <div className="p-4 border-b border-purple-700">
        <h1 className="text-white font-bold text-lg leading-tight">Eden Crest</h1>
        <p className="text-purple-300 text-xs">Girls Hostel</p>
      </div>
      <div className="flex-1 overflow-y-auto py-4">
        {links.map(({ to, icon: Icon, label }) => (
          <NavLink key={to} to={to} end={to === '/'} onClick={() => setOpen(false)}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 text-sm transition-colors ${isActive ? 'bg-purple-700 text-white' : 'text-purple-200 hover:bg-purple-700/50 hover:text-white'}`
            }>
            <Icon size={18} />
            {label}
          </NavLink>
        ))}
      </div>
      <div className="p-4 border-t border-purple-700">
        <p className="text-purple-300 text-xs mb-1">{user?.name}</p>
        <p className="text-purple-400 text-xs mb-3">{user?.role}</p>
        <button onClick={logout} className="flex items-center gap-2 text-purple-200 hover:text-white text-sm w-full">
          <LogOut size={16} /> Logout
        </button>
      </div>
    </nav>
  );

  return (
    <>
      {/* Mobile toggle */}
      <button onClick={() => setOpen(true)} className="md:hidden fixed top-4 left-4 z-50 bg-purple-800 p-2 rounded-md text-white">
        <Menu size={20} />
      </button>
      {/* Mobile overlay */}
      {open && <div className="md:hidden fixed inset-0 z-40 bg-black/50" onClick={() => setOpen(false)} />}
      {/* Mobile drawer */}
      <div className={`md:hidden fixed inset-y-0 left-0 z-50 w-64 bg-purple-900 transform transition-transform ${open ? 'translate-x-0' : '-translate-x-full'}`}>
        <button onClick={() => setOpen(false)} className="absolute top-4 right-4 text-purple-200"><X size={20} /></button>
        {nav}
      </div>
      {/* Desktop sidebar */}
      <div className="hidden md:flex md:flex-col md:w-56 bg-purple-900 min-h-screen flex-shrink-0">
        {nav}
      </div>
    </>
  );
}
